<template>
  <div class="container">
    <div v-if="selectedCompetition">
      <header class="jumbotron">
        <!-- <h1>Norgeslekene</h1> -->
        <!-- <small>(Id:{{content.competition_id}})</small> -->
        <div hidden="hidden">{{ content.competition_id }}</div>
        <h2>{{content.participant_bib}} - {{content.participant_name}} <small>({{content.participant_team}})</small></h2>
          <!-- <small>(Id:{{content.participant_id}})</small> -->
        <div>Epost utøver: {{content.email2}}</div>
        <div>Epost påmelder: {{content.email}}</div>
        <p></p>
        <div>Pålogging for utøver kan også gjøres med Vipps på <a href="https://opprop.andro.no">https://opprop.andro.no</a></div>
        <div>(Vipps pålogging har 15 årsgrense og krever treff på navn/fødselsdato på påmeldingen)</div>
      </header>
        <h4>Øvelser</h4>
        <strong>Endringer kan gjøres frem til utløp av oppropsfrist</strong>
        <!-- <ul class="list-group">
          <li class="list-group-item"
            :class="{ active: index == currentIndex }"
            v-for="(event, index) in content.events"
            :key="index"
          > -->
          <div class="table">
            <div class="row header">
              <div class="cell">Øvelse<br>PB/SB</div>
              <!-- <div class="cell">PB<br>SB</div> -->
              <div class="cell">Start</div>
              <div class="cell">Opprop åpnes<br>Oppropsfrist</div>
              <div class="cell">Status</div>
              <div class="cell">Oppdater</div>
            </div>
            <div class="row" :class="{ active: index == currentIndex }"
            v-for="(event, index) in content.events"
            :key="index">
            <div class="cell">
              {{ event.event }}  {{ event.agegroup }}<br>
              <!-- <small>(Id:{{ event.event_id }})</small> -->
            <!-- </div>
            <div class="cell"> -->
              {{ event.personal_best }} / {{ event.year_best }}
            </div>
            <div class="cell">
              {{ event.event_time | moment('dddd HH:mm')}}<span v-if="event.enterStadium_time">(Innmarsj: {{ event.enterStadium_time | moment('HH:mm')}})</span>
            </div>
            <!-- <div v-if="event.enterStadium_time"> -->
            <div class="cell" v-if="event.callroomregistration_open_time">
              {{ event.callroomregistration_open_time | moment('dddd')}} {{ event.callroomregistration_open_time | moment('HH:mm')}} <br>
              {{ event.callroomregistration_time | moment('dddd')}} {{ event.callroomregistration_time | moment('HH:mm')}}
            </div>
            <div class="cell form-group">
              <!-- <label><strong>Status:</strong></label> -->
              <!-- <span :class="callroom_status_class(index)">{{ event.callroomstatus ? "Avkrysset" : ( (event.callroomregistration_closed_time=='2020-01-01T00:00:00' || event.callroomregistration_closed_time=="2019-12-31T23:00:00.000Z" )  ? "Ikke opprop for øvelse" : "Ikke avkrysset") }}</span>
              <div class="cell"> -->
                <span :class="pill_status_class(event)"
                  >
                  {{ !event.callroomstatus 
                    ? ( !event.callroomstatus_modificationtime 
                        ? 'Ikke avkrysset' 
                        : 'Trukket'
                      ) 
                    : event.callroomstatus 
                    ? "Avkrysset" 
                    : (
                        (event.callroomregistration_closed_time == '2020-01-01T00:00:00' 
                        || event.callroomregistration_closed_time == "2019-12-31T23:00:00.000Z") 
                        ? "Ikke opprop for øvelse" 
                        : "Ikke avkrysset"
                      ) }}
                </span>
              <!-- </div> -->
            </div>
            <div class="cell" v-if="event.modification_open">
              <span v-if="event.callroomstatus">
                <button class="btn btn-info mr-2"
                  @click="updateCallroomStatus(false, index)"
                >
                  Fjern avkryssning
                </button>
                <a class="badge badge-success float-right"
                  :href="'/competition/'+ selectedCompetition.id +'/event/' + event.event_id"
                > 
                  Vis øvelse
                </a>
              </span>
              <button v-else class="btn btn-success mr-2"
                @click="updateCallroomStatus(true, index)"
              >
                Kryss av
              </button>
            </div>
            <div class="cell" v-else>
              <div v-if="Date.parse(event.callroomregistration_closed_time) < content.now ">
                <button class="btn btn-secondary mr-2" disabled>
                  Stengt for endringer<br> (Stengt: {{ event.callroomregistration_closed_time | moment("from", "now")}})
                </button>
                <a class="badge badge-success float-right"
                  :href="'/competition/'+ selectedCompetition.id +'/event/' + event.event_id"
                > 
                  Vis øvelse
                </a>
              </div>
              <div v-else-if="Date.parse(event.callroomregistration_open_time) > content.now ">
                <button class="btn btn-secondary mr-2" disabled>
                  Stengt for endringer<br> (Åpnes: {{ event.callroomregistration_open_time | moment("from", "now")}})
                </button>
                <a class="badge badge-success float-right"
                  :href="'/competition/'+ selectedCompetition.id +'/event/' + event.event_id"
                > 
                  Vis øvelse
                </a>
              </div>
              <div v-else>
                <button class="btn btn-secondary mr-2" disabled>
                  Stengt for endringer
                </button>
                <a class="badge badge-success float-right"
                  :href="'/competition/'+ selectedCompetition.id +'/event/' + event.event_id"
                > 
                  Vis øvelse
                </a>
              </div>
            </div>
            <div class="cell" v-if="debug">
              <div>Now: {{content.now | moment('YYYY-MM-DD HH:mm')}}</div>
              <div>Opentime: {{event.callroomregistration_open_time | moment('YYYY-MM-DD HH:mm')}}</div>
              <div>Closetime: {{event.callroomregistration_closed_time | moment('YYYY-MM-DD HH:mm')}}</div>
              <div>Open for modification: {{event.modification_open}}</div>
              <div>Class: {{pill_status_class(index)}}</div>
              <div>Event: {{event}}</div>
              <div>Resign status: {{event.callroomstatus_resign}}</div>
              <div>Resign status time: {{event.callroomstatus_resign_modification_time}}</div>

            </div>
            </div>
          </div>
          <!-- </li>
        </ul> -->
      <!--
      <p>
        <strong>Token:</strong>
        {{currentUser.accessToken.substring(0, 20)}} ... {{currentUser.accessToken.substr(currentUser.accessToken.length - 20)}}
      </p>
      <p>
        <strong>Id:</strong>
        {{currentUser.id}}
      </p>
      <p>
        <strong>Email:</strong>
        {{currentUser.email}}
      </p>
      <strong>Authorities:</strong>
      <ul>
        <li v-for="(role,index) in currentUser.roles" :key="index">{{role}}</li>
      </ul> -->
    </div>
    <div v-else>
      <div class="alert alert-danger" role="alert">
        <h4>Stevnedetaljer ikke tilgjengelig</h4>
        <p>Stevne ikke tilgjengelig / Stevne ikke valgt </p>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/user.service';
import ParticipantDataService from '../services/ParticipantDataService';
import MyComputed from '../myComputed';

export default {
  mixins: [MyComputed],
  name: 'User',
  data() {
    return {
      content: '',
      currentIndex: -1,
      debug: false
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log(`Watch triggered: ${toParams}  - ${previousParams}`)
        this.getData();
        // react to route changes...
      }
    )
  },
  // async beforeRouteUpdate(to, from) {
  //   // react to route changes...
  //   console.log(`beforeRouteUpdate: ${from} - ${to}`)
  //   this.userData = await this.getData(to.params.id)
  // },
  computed: {
    currentUser() {
      // console.log("currentUser");
      // console.log(this.$store.state.auth.user);
      return this.$store.state.auth.user;
    },
  },
  methods: {
    getData() {
      console.log(`BoardParticipant - getData...`);
      var competition_id = this.$route.params.competition_id;
      var participant_id = '';
      // participant_id = this.$store.state.auth.user.participant_id
      participant_id = this.$route.params.participant_id;
      this.$store.dispatch('competition/setSelectedCompetitionId', competition_id);
      this.$store.dispatch('participant/setSelectedParticipantId', participant_id);
      UserService.getParticipantBoard(competition_id, participant_id).then(
        response => {
          this.content = response.data;
          // console.log(`BoardParticipant - getData - then. competition_id:${competition_id}  participant_id:${participant_id}`);
          // console.log("this.content");
          // console.log(this.content);
          // console.log(this.content.events[0].callroomregistration_closed_time);
        console.log(`HABLE`);
        console.log(this.content);
        this.update_callroom_modification_open();
      },
      error => {
        console.log(`BoardParticipant - getData - error. error:${JSON.stringify(error)}`);
        if ( error.response.status == 302 ) {
          let competition_id = error.response.data.data.competition_id || undefined;
          let participant_id = error.response.data.data.participant_id || undefined;
          if ( competition_id && participant_id ) {
            console.log(`Found new competition_id/participant_id:${competition_id}/${participant_id}`)
            // window.location.href = `/competition/${competition_id}/participant/${participant_id}`;
            // this.$router.go(`/competition/${competition_id}/participant/${participant_id}`);
            // this.$router.push({ path: `/competition/${competition_id}/participant/5002`});
            this.$router.push({ path: `/competition/${competition_id}/participant/${participant_id}`}
            ).then((route) => {
              console.log("this.$router.push -> .then");
              if ( route && route.path && this && this.$route && this.$route.path ) {
                console.log(`HABLE: ${route.path} == ${this.$route.path}`);
                if (route.path === this.$route.path) {
                  throw new Error('Navigation Duplicated TEST')
                }
              }
            // do the actual then processing
            }).catch((error) => { console.error(error) })
          } else {
            console.log("Error")
            console.log(error)
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        } else {
          if ( error.response.status == 440 ) {
            // this.content="Ingen tilgang... -> login"
            if (error.response && error.response.data.message) {
              this.content = error.response.data.message;
              this.message = "("+error.response.data.timedouttime+")";
            } else {
              this.content=
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
            }
            setTimeout(() => {
              this.logOut();
            }, 3000)
          } else {
            console.log("Error")
            console.log(error)
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        }
      });
    },
    is_callroom_modification_open(index) {
      var event = this.content.events[index];
      var now = Date.now();
      this.content.now=now;
      // console.log("now: "+ now+"\ncallroomregistration_open_time: "+Date.parse(event.callroomregistration_open_time) +"\ncallroomregistration_closed_time: "+ Date.parse(event.callroomregistration_closed_time))
      // console.log(Date.parse(event.callroomregistration_open_time) < now);
      // console.log(now - Date.parse(event.callroomregistration_open_time) );
      if ( ! event.callroomregistration_open_time || 
          ( event.callroomregistration_open_time && Date.parse(event.callroomregistration_open_time) < now )) {
            // console.log('2');
            if ( !event.callroomregistration_closed_time || Date.parse(event.callroomregistration_closed_time) > now ) {
              // console.log('3');
              return true;
          }
      }
      return false;
    },
    update_callroom_modification_open() {
      this.content.events.forEach( (event, index) => {
        if ( this.is_callroom_modification_open(index) ) {
          this.content.events[index].modification_open=true
        } else {
          this.content.events[index].modification_open=false
        }
      });
    },
    callroom_status_class(index) {
      // console.log("callroom_status_class...");
      // console.log(this.content.events[index]);
      // console.log(this.content.events[index].callroomregistration_closed_time);
      // console.log(index);
      var event = this.content.events[index];
      var now = Date.now();
      this.content.now=now;
      // No callroom close time
      if ( event.callroomregistration_closed_time == "Ikke opprop for øvelse" 
        || event.callroomregistration_closed_time == "2020-01-01T00:00:00" 
        || event.callroomregistration_closed_time == "2019-12-31T23:00:00.000Z" ) {
        return "badge badge-pill badge-success"
      }
      // Not yet open: badge badge-pill badge-secondary   (Grå)
      if ( event.callroomregistration_open_time && Date.parse(event.callroomregistration_open_time) > now ) {
        return "badge badge-pill badge-secondary"
      }
      if ( ! event.callroomregistration_open_time ||
        (event.callroomregistration_open_time && Date.parse(event.callroomregistration_open_time) < now )) {
        if ( !event.callroomregistration_closed_time || Date.parse(event.callroomregistration_closed_time) > now ) {
          // Open for modification:
          if ( event.callroomstatus ) {
            // Open for modification - signed up: badge badge-pill badge-success   (Grønn)
            return "badge badge-pill badge-success"
          } else {
            // Open for modification - not signed up: badge badge-pill badge-warning   (Gul)
            return "badge badge-pill badge-warning"
          }
        }
      }
      // Closed...
      if ( event.callroomstatus ) {
        // Closed for modification - signed up: badge badge-pill badge-success   (Grønn)
        return "badge badge-pill badge-success"
      } else {
        // Closed for modification - not signed up: badge badge-pill badge-danger   (Rød)
        return "badge badge-pill badge-danger"
      }
    },
    status_class(event_participant) {
      // No callroom close time
      if (event_participant.callroomregistration_time == "Ikke opprop for øvelse"
        || event_participant.callroomregistration_closed_time == "2020-01-01T00:00:00"
        || event_participant.callroomregistration_closed_time == "2019-12-31T23:00:00.000Z") {
        return "success"
      }
      // Not yet open: badge badge-pill badge-secondary   (Grå)
      if (event_participant.callroomregistration_open_time && Date.parse(event_participant.callroomregistration_open_time) > this.now) {
        return "secondary"
      }
      if (!event_participant.callroomregistration_open_time ||
        (event_participant.callroomregistration_open_time && Date.parse(event_participant.callroomregistration_open_time) < this.now)) {
        if (!event_participant.callroomregistration_time || Date.parse(event_participant.callroomregistration_time) > this.now) {
          // Open for modification:
          if (event_participant.callroomstatus) {
            // Open for modification - signed up: badge badge-pill badge-success   (Grønn)
            return "success"
          } else {
            // Open for modification - not signed up: badge badge-pill badge-warning   (Gul)
            if (event_participant.callroomstatus_modificationtime ) {
              return "info"
            } else {
              return "warning"
            }
          }
        }
      }
      // Closed...
      if (event_participant.callroomstatus) {
        // Closed for modification - signed up: badge badge-pill badge-success   (Grønn)
        return "success"
      } else {
        // Closed for modification - not signed up: badge badge-pill badge-danger   (Rød)
        if ( event_participant.callroomstatus_modificationtime ) {
          return "info"
        } else {
          return "danger"
        }
      }
    },
    pill_status_class(event_participant) {
      return "badge badge-pill badge-"+ this.status_class(event_participant);
    },
    alert_status_class(event_participant) {
      return "alert alert-"+ this.status_class(event_participant);
    },
    updateCallroomStatus(status, index) {
      var data = {
        competition_id: this.content.competition_id,
        participant_id: this.content.participant_id,
        event_id: this.content.events[index].event_id,
        callroomstatus: status
      };

      ParticipantDataService.update(data)
        .then(() => {
          this.content.events[index].callroomstatus = status;
        })
        // .then(response => {
        //   this.content.events[index].callroomstatus = status;
        //   console.log(response.data);
        // })
        .catch(e => {
          console.log(e);
        });

      // console.log(status);
      // console.log(index);
      // console.log(this.content.participant_id);
      // console.log(this.content.events[index].event_id);
      // Oppdater gui
      // this.content.events[index].callroomStatus = status;
      // Oppdater backend

    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
};
</script>


<style scoped>
.table {
  display: table;
  width: 100%;
  border-collapse: collapse;
}

.row {
  display: table-row;
}

.header {
  font-weight: bold;
}

.cell {
  display: table-cell;
  padding: 5px;
  border: 1px solid black;
  white-space: nowrap;
}

.badge-success {
  background-color: #28a745 !important;
}
.badge-warning {
  background-color: #ffc107 !important;
}
.badge-danger {
  background-color: #dc3545 !important;
}
.badge-info {
  background-color: #17a2b8 !important;
}
.badge-secondary {
  background-color: #6c757d !important;
}
</style>
